import { createMultiStyleConfigHelpers, theme } from '@chakra-ui/react';
import { fontSizes } from '~/common/customTheme/font';
import { tabsAnatomy } from '@chakra-ui/anatomy';

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(tabsAnatomy.keys);

const baseStyle = definePartsStyle((props) => {
  const enclosed = theme.components.Tabs.variants?.enclosed(props);
  return {
    ...enclosed,
    tab: {
      ...enclosed?.tab,
      fontWeight: 'semibold',
      fontSize: fontSizes.lg,
      _selected: {
        ...enclosed?.tab?._selected,
        color: 'green.600',
      },
    },
  };
});

// export the component theme
export const tabsTheme = defineMultiStyleConfig({
  variants: { its4: baseStyle },
  defaultProps: { variant: 'its4' },
});
